import { CircularProgress, CircularProgressProps, Box } from '@mui/material';

type Props = CircularProgressProps;

/** @deprecated */
export const Loading: React.FC<Props> = ({ size, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}
      data-testid="loading"
    >
      <CircularProgress color="primary" size={size} sx={sx} />
    </Box>
  );
};
